import ElementConstants from '../../../shared/constants/elements';

const PaymentBlocks = {
    OPEN: {
        type: ElementConstants.PAYMENTS.OPEN,
        label: 'Open',
        icon: 'money-symbol'
    },
    MULTI_CHOICE: {
        type: ElementConstants.PAYMENTS.MULTI_CHOICE,
        label: 'Multiple Choice',
        icon: 'dollar-circle-dot'

    },
    ITEM: {
        type: ElementConstants.PAYMENTS.ITEM,
        label: 'Item',
        icon: 'tag-symbol'
    }
};

export default PaymentBlocks;



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/constants/blocks/payments.js